import { combineReducers } from 'redux';
import userReducer from './userReducer';
import usersuggestionReducer from './usersuggestionReducer';
import tokenReducer from './tokenReducer';
import loginlogReducer from './loginlogReducer';
import clientReducer from './clientReducer';
import prospectReducer from './prospectReducer';
import visitorReducer from './visitorReducer';
import societeReducer from './societeReducer';
import societegroupReducer from './societegroupReducer';
import bienReducer from './bienReducer';
import encaissementReducer from './encaissementReducer';
import encaissementlineReducer from './encaissementlineReducer';
import banqueversementReducer from './banqueversementReducer';
import bankReducer from './bankReducer';
import venteReducer from './venteReducer';
import associationReducer from './associationReducer';
import doaReducer from './doaReducer';
import drReducer from './drReducer';
import promoteurReducer from './promoteurReducer';
import commissionhistoryReducer from './commissionhistoryReducer';
import commissionbulletinReducer from './commissionbulletinReducer';
import commissionpaymentReducer from './commissionpaymentReducer';
import formulaReducer from './formulaReducer';
import formulainstanceReducer from './formulainstanceReducer';
import formulasocietedefaultReducer from './formulasocietedefaultReducer';
import goalReducer from './goalReducer';
import goalsocietedefaultReducer from './goalsocietedefaultReducer';
import budgetReducer from './budgetReducer';
import divisionReducer from './divisionReducer';
import divisionsampleReducer from './divisionsampleReducer';
import divisionpartitiontypeReducer from './divisionpartitiontypeReducer';
import encsortiReducer from './encsortiReducer';
import notificationReducer from './notificationReducer';
import notificationModelReducer from './notificationModelReducer';
import recyreqReducer from './recureqReducer';
import errorReducer from './errorReducer';
import authReducer from './authReducer';

export default combineReducers({
  user: userReducer,
  usersuggestion: usersuggestionReducer,
  token: tokenReducer,
  loginlog: loginlogReducer,
  client: clientReducer,
  prospect: prospectReducer,
  visitor: visitorReducer,
  societe: societeReducer,
  societegroup: societegroupReducer,
  bien: bienReducer,
  encaissement: encaissementReducer,
  encaissementline: encaissementlineReducer,
  banqueversement: banqueversementReducer,
  bank: bankReducer,
  vente: venteReducer,
  association: associationReducer,
  doa: doaReducer,
  dr: drReducer,
  promoteur: promoteurReducer,
  commission_history: commissionhistoryReducer,
  commission_bulletin: commissionbulletinReducer,
  commission_payment: commissionpaymentReducer,
  formula: formulaReducer,
  formula_instance: formulainstanceReducer,
  formula_societe_default: formulasocietedefaultReducer,
  goal: goalReducer,
  goal_societe_default: goalsocietedefaultReducer,
  budget: budgetReducer,
  division: divisionReducer,
  division_sample: divisionsampleReducer,
  division_partition_type: divisionpartitiontypeReducer,
  enc_sorti: encsortiReducer,
  notification: notificationReducer,
  notification_model: notificationModelReducer,
  recu_req: recyreqReducer,
  error: errorReducer,
  auth: authReducer
});
